import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
// import reportWebVitals from './helpers/report-web-vitals';
import configureStore from './redux/store/configureStore'
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { installAxiosAuthInterceptor } from './utils/axios-auth';


const root = ReactDOM.createRoot(document.getElementById('root'));
const { store, persistor } = configureStore()
installAxiosAuthInterceptor();

root.render(
  <Provider store = { store }>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  // <React.StrictMode>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
